import request from '@/utils/request'

// 记录系统访问数量
export function addVisit(data) {
  return request({
    url: '/business/loginFree/addVisit',
    method: 'post',
    data: data
  })
}

// 获取免登录新闻列表
export function articleList(data) {
  const url = '/business/loginFree/articleList'
  const params = new URLSearchParams(data);
  return request({
    url: `${url}?${params.toString()}`,
    method: 'get'
  })
}

// 获取单条详情
export function getArticle(data) {
  return request({
    url: '/business/loginFree/article/' + data,
    method: 'get'
  })
}

// 获取类型二级类型列表
export function typeList(data) {
  const url = '/business/loginFree/typeList'
  const params = new URLSearchParams(data);
  return request({
    url: `${url}?${params.toString()}`,
    method: 'get'
  })
}

// 获取产权列表
export function knowledgeList(data) {
  const url = '/business/loginFree/knowledgeList'
  const params = new URLSearchParams(data);
  return request({
    url: `${url}?${params.toString()}`,
    method: 'get'
  })
}

// 产权申请
export function apply(data) {
  return request({
    url: '/business/apply',
    method: 'post',
    data: data
  })
}

// 品牌列表
export function brandList(data) {
  const url = '/business/loginFree/brandList'
  const params = new URLSearchParams(data);
  return request({
    url: `${url}?${params.toString()}`,
    method: 'get'
  })
}

// 查询公司名称
export function companyInfo(data) {
  const url = '/business/loginFree/companyInfo'
  const params = new URLSearchParams(data);
  return request({
    url: `${url}?${params.toString()}`,
    method: 'get'
  })
}

// 专利评估类型接口
export function patentTypes(data) {
  const url = '/business/loginFree/patentTypes'
  const params = new URLSearchParams(data);
  return request({
    url: `${url}?${params.toString()}`,
    method: 'get'
  })
}

// 专利评估
export function getPatentEval(data) {
  return request({
    url: '/business/evaluation/getPatentEval',
    method: 'post',
    data: data
  })
}

// 个人中心
export function person(data) {
  const url = '/business/pub/person'
  const params = new URLSearchParams(data);
  return request({
    url: `${url}?${params.toString()}`,
    method: 'get'
  })
}

// 新增投诉
export function complaint(data) {
  return request({
    url: '/business/complaint',
    method: 'post',
    data: data
  })
}

// 文件上传/删除
export function uploadDocs(data) {
  return request({
    url: '/common/uploadDocs',
    method: 'post',
    data: data
  })
}

// 新增商标入库申请
export function trademark(data) {
  return request({
    url: '/business/trademark',
    method: 'post',
    data: data
  })
}

// 获取投诉详情
export function complaintDetail(data) {
  return request({
    url: '/business/loginFree/complaint/' + data,
    method: 'get'
  })
}

// 获取知识产权详情
export function knowledgeApply(data) {
  return request({
    url: '/business/loginFree/knowledgeApply/' + data,
    method: 'get'
  })
}

// 商标详情
export function trademarkDetail(data) {
  return request({
    url: '/business/loginFree/trademark/' + data,
    method: 'get'
  })
}

// 文章浏览次数
export function addArticleRead(data) {
  return request({
    url: '/business/loginFree/addArticleRead',
    method: 'post',
    data: data
  })
}

// 新增服务申请
export function serviceApply(data) {
  return request({
    url: '/business/serviceApply',
    method: 'post',
    data: data
  })
}
// 出海服务详情
export function serviceApplyDetail(data) {
  return request({
    url: '/business/serviceApply/' + data,
    method: 'get'
  })
}
// 商标跳转获取token
export function getBaiTuZhiNengToken() {
  return request({
    url: '/business/loginFree/getBaiTuZhiNengToken',
    method: 'get'
  })
}

// 出海服务申请
export function seaApply(data) {
  return request({
    url: '/business/overseasServiceApply/apply',
    method: 'post',
    data: data
  })
}

// 出海服务详情
export function seaApplyDetail(data) {
  return request({
    url: '/business/overseasServiceApply/' + data,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/hangzhi.js